import { render } from "./ConfigGeral.vue?vue&type=template&id=28152633"
import script from "./ConfigGeral.vue?vue&type=script&lang=js"
export * from "./ConfigGeral.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__